import React from 'react';
import { Product } from '../../types';
import { ProductCard } from './ProductCard';
interface ProductGridProps {
  products: Product[];
  onQuickView?: (product: Product) => void;
  columns?: 2 | 3 | 4 | 5;
}
export function ProductGrid({
  products,
  onQuickView,
  columns = 4
}: ProductGridProps) {
  const gridCols = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
    5: 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'
  };
  if (products.length === 0) {
    return <div className="text-center py-12" data-id="element-841" data-mp="278wkhgwp0adx">
        <p className="text-gray-500" data-id="element-842" data-mp="277va7eni3rx9">No products found</p>
      </div>;
  }
  return <div className={`grid ${gridCols[columns]} gap-4 md:gap-6`} data-id="element-843" data-mp="229a819oouy66">
      {products.map(product => <ProductCard key={product.id} product={product} onQuickView={onQuickView} data-id="element-844" data-mp="2zpz4enuvd886" />)}
    </div>;
}